import React from "react";
import { useNavigate } from "react-router-dom";

const TrailerTruck = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-cs-bg-alt py-8 px-4">
            <div className="max-w-auto mx-auto space-y-6">
                {/* Header */}
                <header className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.18em] text-cs-muted">
                            Fleet center
                        </p>
                        <h1 className="text-2xl font-semibold text-cs-dark">
                            Trucks & Trailers
                        </h1>
                        <p className="text-sm text-cs-muted mt-1">
                            Manage your units, assign assets and keep your equipment list
                            updated in one centralized view.
                        </p>
                    </div>
                </header>

                {/* Cards */}
                <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Trucks */}
                    <div
                        className="
                            bg-cs-bg
                            border border-cs-border
                            rounded-2xl
                            p-4
                            shadow-sm
                            flex flex-col justify-between
                            gap-3
                        "
                    >
                        <div className="flex items-start justify-between gap-2">
                            <div className="flex flex-col gap-1">
                                <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-cs-primary-soft text-cs-primary-dark text-[9px]">
                                    <span className="material-symbols-outlined text-[12px]">
                                        local_shipping
                                    </span>
                                    Power units
                                </div>
                                <h2 className="text-sm font-semibold text-cs-dark">
                                    Trucks
                                </h2>
                                <p className="text-[10px] text-cs-muted">
                                    Register tractors, assign plates, VINs and status for dispatch
                                    and compliance.
                                </p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => navigate("/trucks")}
                            className="
                                mt-2
                                inline-flex items-center justify-center gap-1.5
                                px-3 py-2
                                rounded-xl
                                bg-cs-primary
                                text-white
                                text-[10px] font-medium
                                hover:bg-cs-primary-hover
                                transition-all
                                shadow-sm hover:shadow-md
                            "
                        >
                            <span className="material-symbols-outlined text-[14px]">
                                dashboard
                            </span>
                            Go to Trucks list
                        </button>
                    </div>

                    {/* Trailers */}
                    <div
                        className="
                            bg-cs-bg
                            border border-cs-border
                            rounded-2xl
                            p-4
                            shadow-sm
                            flex flex-col justify-between
                            gap-3
                        "
                    >
                        <div className="flex items-start justify-between gap-2">
                            <div className="flex flex-col gap-1">
                                <div className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-cs-bg-alt text-cs-primary-dark text-[9px] border border-cs-primary-soft">
                                    <span className="material-symbols-outlined text-[12px]">
                                        inventory_2
                                    </span>
                                    Trailers
                                </div>
                                <h2 className="text-sm font-semibold text-cs-dark">
                                    Trailers
                                </h2>
                                <p className="text-[10px] text-cs-muted">
                                    Control dry vans, reefers, flats and more. Track availability,
                                    specs and pairing.
                                </p>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => navigate("/trailers")}
                            className="
                                mt-2
                                inline-flex items-center justify-center gap-1.5
                                px-3 py-2
                                rounded-xl
                                bg-cs-primary-soft
                                text-cs-primary-dark
                                text-[10px] font-medium
                                hover:bg-cs-primary
                                hover:text-white
                                transition-all
                                shadow-sm hover:shadow-md
                            "
                        >
                            <span className="material-symbols-outlined text-[14px]">
                                table_rows
                            </span>
                            Go to Trailers list
                        </button>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default TrailerTruck;
